// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { hideElementOnPrint, layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            width: 100%;
            & > div {
                ${layoutContainer};
                display: flex;
                flex-wrap: wrap;
                flex: 1;
                gap: 12px;
            }
        `,
        drawerBody: css`
            top: auto;
            bottom: 0;
            justify-content: center;

            ${xScreen("lt", "md")} {
                && {
                    display: flex;
                }
            }

            ${xScreen("lt", "sm")} {
                && {
                    height: 32dvh;
                }
            }
        `,
        scrim: css`
            ${hideElementOnPrint}
            top: auto;
            bottom: 0;
            ${hideElementOnPrint}
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    css: css`
        flex: 1 0 auto;
        width: 100%;
        padding-top: 4px;
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    css: css`
        width: fit-content;
    `,
};
cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "secondary",
    css: css`
        width: fit-content;
    `,
};
